import React from "react";
import { Button } from "react-bootstrap";
import { LoadingSpinner } from "../../common/Loading/LoadingSpinner";

interface TaskFormFooterProps {
  isSubmitting: boolean;
  visibleRecurring: boolean;
  setVisibleRecurring: (visible: boolean) => void;
  onClose: () => void;
}

export const TaskFormFooter: React.FC<TaskFormFooterProps> = ({
  isSubmitting,
  visibleRecurring,
  setVisibleRecurring,
  onClose,
}) => (
  <div className="d-flex justify-content-between align-items-center w-100">
    <div className="form-group">
      <Button
        variant="outline-dark"
        className="me-2"
        onClick={() => setVisibleRecurring(!visibleRecurring)}
      >
        {visibleRecurring ? "Single Task" : "Recurring Task"}
      </Button>
    </div>
    <div className="form-group">
      <Button variant="primary" disabled={isSubmitting} type="submit" className="me-2">
        {isSubmitting ? <LoadingSpinner text="Creating task..." /> : "Create Task"}
      </Button>
      <Button variant="secondary" onClick={onClose}>
        Cancel
      </Button>
    </div>
  </div>
);
